// ======================================================================
// File Name       : ModalWrapper
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { HIDE_MESSAGE } from '../../constants/actionTypes/message';
import store from '../../store';
import MessageView from '../MessageView';

class ModalWrapper extends Component {
  constructor(props) {
    super(props);
    this.dismissMessage = this.dismissMessage.bind(this);
  }

  componentWillUnmount() {
    this.dismissMessage();
  }

  dismissMessage() {
    store.dispatch({
      type: HIDE_MESSAGE,
    });
  }

  render() {
    const {
      show,
      title,
      bsSize,
      children,
      footerBtns,
      hideModal,
      fixedHeight,
      temporaryHide,
      dialogClassName,
      style,
      bodyClassName,
    } = this.props;

    const footer =
      footerBtns &&
      footerBtns.map(({ name, onClick = hideModal, bsStyle, className, disabled = false, variant }, index) =>
        (<Button variant={variant} key={index} {...{ bsStyle, onClick, className: `${className} btn-96`, disabled }}>
          {name}
        </Button>),
      );

    const message = store.getState().message;
    return (
      <Modal
        show={show}
        animation={false}
        size={bsSize}
        className={(temporaryHide ? ' hidden' : '')}
        dialogClassName={dialogClassName || ''}
        style={style || ''}
      >
        <Modal.Header onHide={hideModal} closeButton>
          <Modal.Title>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={bodyClassName || ''}>
          <div className="padding-left-20 padding-right-20 breakDot">
            {message && message.targetModal &&
              <MessageView
                message={message}
                onDismiss={this.dismissMessage}
              />}
            {children}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {footer}
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalWrapper.propTypes = {
  title: PropTypes.string,
  bsSize: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element, PropTypes.string]),
  footerBtns: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      onClick: PropTypes.func,
      variant: PropTypes.string,
      className: PropTypes.string,
      disabled: PropTypes.bool,
    }),
  ),
  hideModal: PropTypes.func.isRequired,
  fixedHeight: PropTypes.bool,
};

ModalWrapper.defaultProps = {
  title: '',
  bsSize: 'lg',
  children: null,
  footerBtns: [],
  fixedHeight: true,
  show: true,
};

export default ModalWrapper;
